module.exports = __webpack_public_path__ + "img/savology-screen-9.599f4e79.png";